// extracted by mini-css-extract-plugin
var _1 = "side-panel---active---UX3fC";
var _2 = "side-panel---header---ESf98";
var _3 = "side-panel---headerButton---UszHS";
var _4 = "side-panel---headerTitle---np72G";
var _5 = "side-panel---overlay---F5hX1";
var _6 = "side-panel---sidePanel---oyuRD";
export { _1 as "active", _2 as "header", _3 as "headerButton", _4 as "headerTitle", _5 as "overlay", _6 as "sidePanel" }
